import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  Output,
  PLATFORM_ID,
} from '@angular/core';
import { Currency, FeaturedListing } from '../services/api/api.service';
import { LoginService } from '@app/login.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { AngularSvgIconModule } from 'angular-svg-icon';
import {
  CommonModule,
  NgOptimizedImage,
  isPlatformServer,
} from '@angular/common';
import { CardComponent } from '@app/card/card.component';
import { SkeletonCardComponent } from '@app/skeleton-card/skeleton-card.component';
import { Observable } from 'rxjs';
import { LocaleService } from '@app/locale.service';
import { FirstRenderDirective } from '@app/first-render.directive';

@Component({
  selector: 'app-cards-mobile',
  templateUrl: './cards-mobile.component.html',
  styleUrls: ['./cards-mobile.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    AngularSvgIconModule,
    NgOptimizedImage,
    CardComponent,
    SkeletonCardComponent,
    FirstRenderDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('0.3s ease-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('0.3s ease-out', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class CardsMobileComponent {
  @Input()
  public hostels: FeaturedListing[] = [];
  @Input()
  public skeleton = false;

  @Output()
  public select = new EventEmitter<FeaturedListing>();

  public mockHostels: any[] = Array.from({ length: 10 }, (_) => {});
  public currency: Observable<Currency>;

  constructor(
    private loginService: LoginService,
    private localeService: LocaleService,
    @Inject(PLATFORM_ID) private platformId: string
  ) {}

  public navigateToHostelDetails(hostel: FeaturedListing) {
    this.select.emit(hostel);
  }

  ngOnInit() {
    this.currency = this.localeService.currentCurrency;

    if (isPlatformServer(this.platformId)) {
      this.hostels = [{} as FeaturedListing];
      this.skeleton = false;
    }
  }

  public trackById(_: number, hostel: any) {
    return hostel._id;
  }
}
